import Vue from "vue";
import Vuex from "vuex";
import Interface from "./interface.js";
import flashMessage from "./flashMessage.js";
import wording from "./wording.js";
import common from "./common.js";
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    Interface,
    flashMessage,
    wording,
    common
  },
});

export default store;